export function hexToRgb(hex, alpha) {
    if (hex === void 0) { hex = ''; }
    if (alpha === void 0) { alpha = '1'; }
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? "rgba(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ", ").concat(alpha, ")")
        : null;
}
export var ellipsisText = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal',
};
export function expandBorderStyles(borderStyles) {
    return {
        borderTopWidth: borderStyles.borderWidth,
        borderTopStyle: borderStyles.borderStyle,
        borderTopColor: borderStyles.borderColor,
        borderBottomWidth: borderStyles.borderWidth,
        borderBottomStyle: borderStyles.borderStyle,
        borderBottomColor: borderStyles.borderColor,
        borderLeftWidth: borderStyles.borderWidth,
        borderLeftStyle: borderStyles.borderStyle,
        borderLeftColor: borderStyles.borderColor,
        borderRightWidth: borderStyles.borderWidth,
        borderRightStyle: borderStyles.borderStyle,
        borderRightColor: borderStyles.borderColor,
    };
}
